import axios from "axios";
import { getLibraryTypeByLibrary, LibraryType } from "../types/Library";

const SITE_TYPE_CONFIG: Record<LibraryType, { apiBaseUrl: string; siteDomain: string }> = {
  busan: {
    apiBaseUrl: "https://server.greeneffect.co.kr:28080",
    siteDomain: "",
  },
  asan: {
    apiBaseUrl: "https://server.greeneffect.co.kr:38080",
    siteDomain: "",
  },
};

const api = axios.create({
  baseURL: SITE_TYPE_CONFIG.busan.apiBaseUrl,
});

api.interceptors.request.use((config) => {
  const parsedLibrary = window.sessionStorage.getItem("library");
  const savedLibrary = parsedLibrary ? JSON.parse(parsedLibrary) : null;
  const libraryType = getLibraryTypeByLibrary(savedLibrary);

  config.baseURL = SITE_TYPE_CONFIG[libraryType].apiBaseUrl;
  return config;
});

export default api;
